export const paperStyle = { my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 }, width: "100%" };
